"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var base64url_1 = require("./base64url");
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.isString = function (s) {
        return typeof s === 'string';
    };
    Utils.utf8ToUint8Array = function (str) {
        str = btoa(unescape(encodeURIComponent(str)));
        return base64url_1.Base64URL.parse(str);
    };
    Utils.isFunction = function (fn) {
        return typeof fn === 'function';
    };
    Utils.isObject = function (arg) {
        return arg !== null && typeof arg === 'object';
    };
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map